<template>
  <xer-zenomo-layout>
    <template #header>
      <xer-header
        id="overzicht-header"
        class="xer-l-application__header xer-mb-7 tablet:xer-m-0"
        :xer-logo-link="null"
      />
    </template>

    <component :is="errorComponent" v-bind="errorComponentProps"></component>

    <template #footer>
      <xer-footer class="xer-hidden tablet:xer-block" />
    </template>
  </xer-zenomo-layout>
</template>

<script>
import XerZenomoLayout from '@/components/XerZenomoLayout.vue';
import { XerHeader } from '@xerius/codey-components-vue2';
import XerFooter from '@/components/XerFooter';
import errorComponents from '@/components/errors/index';
import XerLogin from '@/components/XerLogin.vue';

export default {
  name: 'Oeps',
  components: {
    XerZenomoLayout,
    XerHeader,
    XerFooter,
    ...errorComponents,
    XerLogin
  },
  props: {
    errorComponent: {
      type: String,
      default: 'XerOeps'
    },
    errorComponentProps: {
      type: Object,
      default: undefined
    }
  }
};
</script>
